import "./Header.css"

export default function Header(){
    const heading = "Always Providing"
    const heading2 = "Compassionate and Quality"
    const heading3 = "Home Health Care for Your Loved Ones"
    return (
        <section id="home">
            <div id="Header">
                <h2 className="subheading">{heading}</h2>
                <h2 className="subheading">{heading2}</h2>
                <div id="button_heading">
                    {/* <button className='more_info_button'>MORE INFO</button> */}
                    <h2 className="subheading">{heading3}</h2>
                </div>
            </div>
            <div id="spacing"></div>
        </section>
    )
}